import * as React from "react";

import "./WizardStepLayout.css";

export interface WizardStepLayoutProps {
  title: React.ReactChild;
  banner: React.ReactChild;
  children: React.ReactChild;
  footnote?: React.ReactChild;
  reqInputValue?: string;
  reqInputPlaceholder?: string;
  onReqInputChange?: (e: React.SyntheticEvent<HTMLInputElement>) => void;
}

const LayoutChoice = (props: WizardStepLayoutProps) => (
  <div className="container wizard-step">
    <div className="row">
      <div className="col-md-8 col-md-offset-2">
        <div className="wizard-step__header">
          <h1>{props.title}</h1>
          <p className="help-text hidden-xs">{props.banner}</p>
        </div>
        {props.children}
        <div className="wizard-step__footer">
          {props.footnote != null && (
            <p className="wizard-step__footnote">{props.footnote}</p>
          )}
          {props.onReqInputChange != null &&
          props.reqInputValue != null && (
            <input
              className="wizard-step__request-input"
              type="text"
              placeholder={props.reqInputPlaceholder}
              value={props.reqInputValue}
              onChange={props.onReqInputChange}
            />
          )}
        </div>
      </div>
    </div>
  </div>
);

export default LayoutChoice;



// WEBPACK FOOTER //
// ./src/routes/Wizard/components/WizardStepLayout.tsx